import { SHORTCODE_REG } from "@libs/useful/shortcode/parseShortcode";
import { HTML } from "../interfaces/layouts";

export const wordTrim = (text: HTML, count: number) : string => {
    let newText: string = text
        .replace(/<[^>]*>?/gm, '')
        .replace( SHORTCODE_REG, "")
        .split(" ")
        .splice(0, count)
        .join(" ")
    if(text !== newText) {
        newText += "..."
    } 
    return newText
}
export const letterTrim = (text: HTML, count: number) : string => {
    let newText: string = text
        .replace(/<[^>]*>?/gm, '')
        .replace( SHORTCODE_REG, "")
        .substring(0, count)
    if(text !== newText) {
        newText += "..."
    } 
    return newText
}